module.exports = __webpack_public_path__ + "img/logo_anjie.ffe50423.jpg";